exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select:invalid,select option[value=\"\"]{color:#999}", ""]);

// exports
